<template>
    <div></div>
</template>
<script>

// External libraries
import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState('core/auth', [
            'user',
            'userLink'
        ]),

        ...mapState('core/tenants', [
            'selectedTenant'
        ]),

        ...mapState('core/session', [
            'pendingRequests'
        ])
    },

    methods: {
        ...mapActions('core/tenants', { selectUserTenant: 'selectUserTenant' }),

        ...mapActions('core/auth', ['getAuthenticatedUser']),

        /**
         * When chosing a tenant check if user is admin
         *
         * @param    {string}    tenantId     the tenant id
         *
         * @retun    void
         */
        chooseTenant (tenantId) {
            // Return early if already chosen
            if (this.selectedTenant.id === tenantId || this.pendingRequests > 0) {
                return;
            }

            // Select the new tenant
            this.selectUserTenant({ id: tenantId })
                .then(() => {
                    // When we switch to another tenant we refresh the authenticated user to update its permissions
                    this.getAuthenticatedUser().then(() => {
                        // Redirect user to home page
                        this.$router.push({ name: `home:${this.$i18n.locale}` });
                    });
                });
        }
    }
};
</script>
